import { Component } from '@theme/component';

/**
 * A custom element that allows the user to toggle the unit of the size guide table.
 *
 * @typedef {Object} Refs
 * @property {HTMLTableColElement} firstColumn
 * @property {HTMLButtonElement} cmButton
 * @property {HTMLButtonElement} inchButton
 * @property {HTMLSpanElement} switcher
 *
 * @extends {Component<Refs>}
 */
export class SizeGuideTableComponent extends Component {
  requiredRefs = ['firstColumn', 'cmButton', 'inchButton', 'switcher'];

  connectedCallback() {
    super.connectedCallback();
    const { firstColumn, switcher } = this.refs;
    firstColumn.style.width = `${switcher.offsetWidth}px`;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  /**
   * Toggles the unit of the size guide table.
   * @param {Event} event - The event.
   */
  toggleUnit(event) {
    const { target } = event;

    if (!(target instanceof HTMLButtonElement)) return;

    const currentUnit = this.dataset.unit;
    const newUnit = target.value;

    if (currentUnit === newUnit) return;

    const { cmButton, inchButton } = this.refs;

    if (newUnit === 'cm') {
      cmButton.setAttribute('aria-pressed', 'true');
      inchButton.setAttribute('aria-pressed', 'false');
    } else {
      cmButton.setAttribute('aria-pressed', 'false');
      inchButton.setAttribute('aria-pressed', 'true');
    }

    this.dataset.unit = newUnit;
  }
}

if (!customElements.get('size-guide-table-component')) {
  customElements.define('size-guide-table-component', SizeGuideTableComponent);
}
